// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NasiOdjeli_wrapper__jVbgt {
  margin-top: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background-color: #f5f5f5;
  padding: 60px;
}
.NasiOdjeli_grid__T\\+A0u {
  display: grid;
  align-items: center;
  justify-content: center;
  width: 80%;
  gap: 20px;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  row-gap: 50px;
}
.NasiOdjeli_h4__TTuHb,
.NasiOdjeli_h2__rO5H2 {
  font-family: "Lato";
  font-weight: 800;
  letter-spacing: 0px;
  text-align: center;
}
.NasiOdjeli_h4__TTuHb {
  font-size: 20px;
  color: #bcbcbc;
  margin-block-end: 0px;
  margin-block-start: 0px;
}
.NasiOdjeli_h2__rO5H2 {
  font-size: 36px;
  color: #090446;
  max-width: 18ch;
}

@media screen and (max-width: 1280px) {
  .NasiOdjeli_grid__T\\+A0u {
    width: 50%;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    gap: 40px;
  }
  .NasiOdjeli_wrapper__jVbgt {
    margin-top: 650px;
  }
}

@media screen and (max-width: 1150px) {
  .NasiOdjeli_grid__T\\+A0u {
    width: 50%;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    gap: 40px;
  }
  .NasiOdjeli_wrapper__jVbgt {
    margin-top: 650px;
  }
}

@media screen and (max-width: 680px) {
  .NasiOdjeli_wrapper__jVbgt {
    padding: 50px 0;
  }
  .NasiOdjeli_h2__rO5H2 {
    font-size: 32px;
  }
  .NasiOdjeli_grid__T\\+A0u {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    gap: 15px;
  }
}

@media screen and (max-width: 425px) {
  .NasiOdjeli_wrapper__jVbgt {
    margin-top: 650px;
    position: absolute;
    width: 100%;
    left: 0;
    border-radius: 0px;
    box-sizing: border-box;
  }
  .NasiOdjeli_h2__rO5H2 {
    font-size: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/HomePage/components/NasiOdjeli/NasiOdjeli.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,qCAAqC;EACrC,kCAAkC;EAClC,aAAa;AACf;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,qCAAqC;IACrC,wBAAwB;IACxB,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,qCAAqC;IACrC,wBAAwB;IACxB,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,qCAAqC;IACrC,wBAAwB;IACxB,SAAS;EACX;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".wrapper {\n  margin-top: 600px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  background-color: #f5f5f5;\n  padding: 60px;\n}\n.grid {\n  display: grid;\n  align-items: center;\n  justify-content: center;\n  width: 80%;\n  gap: 20px;\n  grid-template-columns: repeat(4, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  row-gap: 50px;\n}\n.h4,\n.h2 {\n  font-family: \"Lato\";\n  font-weight: 800;\n  letter-spacing: 0px;\n  text-align: center;\n}\n.h4 {\n  font-size: 20px;\n  color: #bcbcbc;\n  margin-block-end: 0px;\n  margin-block-start: 0px;\n}\n.h2 {\n  font-size: 36px;\n  color: #090446;\n  max-width: 18ch;\n}\n\n@media screen and (max-width: 1280px) {\n  .grid {\n    width: 50%;\n    grid-template-columns: repeat(3, 1fr);\n    grid-template-rows: auto;\n    gap: 40px;\n  }\n  .wrapper {\n    margin-top: 650px;\n  }\n}\n\n@media screen and (max-width: 1150px) {\n  .grid {\n    width: 50%;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: auto;\n    gap: 40px;\n  }\n  .wrapper {\n    margin-top: 650px;\n  }\n}\n\n@media screen and (max-width: 680px) {\n  .wrapper {\n    padding: 50px 0;\n  }\n  .h2 {\n    font-size: 32px;\n  }\n  .grid {\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: auto;\n    gap: 15px;\n  }\n}\n\n@media screen and (max-width: 425px) {\n  .wrapper {\n    margin-top: 650px;\n    position: absolute;\n    width: 100%;\n    left: 0;\n    border-radius: 0px;\n    box-sizing: border-box;\n  }\n  .h2 {\n    font-size: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `NasiOdjeli_wrapper__jVbgt`,
	"grid": `NasiOdjeli_grid__T+A0u`,
	"h4": `NasiOdjeli_h4__TTuHb`,
	"h2": `NasiOdjeli_h2__rO5H2`
};
export default ___CSS_LOADER_EXPORT___;
